import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import objectPath from 'object-path';

import { clientStore } from 'apps/client/app';

import { DirLink, DirName, ContribMode } from 'apps/repository/styles';

@withNamespaces()
@observer
export class BreadCrumbs extends React.Component {
  render() {
    const {
      basepathSegs,
      routeParams,
      repoManager,
      projectRouteParams,
      content,
      isFile = false,
    } = this.props;
    const projectRoute = `${clientStore.spaceRoute.route}`;
    const driveRouteParams = Object.assign({}, projectRouteParams);
    delete driveRouteParams.basepath;

    const pathLinks = [
      <span key='-1'>
        <DirLink
          name={`${projectRoute}.files`}
          params={driveRouteParams}
          content={content}
          first
        >
          Drive
        </DirLink>
        <DirName>&nbsp;/&nbsp;</DirName>
      </span>,
    ];
    // FIXME - replace with map
    // eslint-disable-next-line
    for (const [index, bpath] of basepathSegs.entries()) {
      if (index + 1 === basepathSegs.length) {
        if (isFile) {
          pathLinks.push(<DirName key={index}>{bpath}</DirName>);
        } else {
          pathLinks.push(<DirName key={index}>{bpath}&nbsp;/</DirName>);
        }
      } else {
        const dirParams = Object.assign({}, routeParams, {
          basepath: basepathSegs.slice(0, index + 1).join('/'),
        });
        pathLinks.push(
          <span key={index}>
            <DirLink
              name={`${projectRoute}.files.directory`}
              params={dirParams}
              content={content}
            >
              {bpath}
            </DirLink>
            <DirName>&nbsp;/&nbsp;</DirName>
          </span>,
        );
      }
    }

    const repository = objectPath.get(repoManager, 'repository');
    // also used on individual ContributionFile pages (no RepoAppManager)
    if (!repoManager.atHead) {
      pathLinks.push(
        <ContribMode key='contribId'>
          <Trans>({`#${repoManager.variables.version}`})</Trans>
        </ContribMode>,
      );
    }
    return <Wrapper>{pathLinks}</Wrapper>;
  }
}

const Wrapper = styled.div`
  margin-bottom: 20px;
  width: calc(100% - 100px);
  word-break: break-all;
`;

BreadCrumbs.propTypes = {
  basepathSegs: PropTypes.array,
  routeParams: PropTypes.object,
  projectRouteParams: PropTypes.object,
  repoManager: PropTypes.object,
  content: PropTypes.object,
  isFile: PropTypes.bool,
};
